import React from 'react'
import { Space, Typography } from 'antd'
import { DocumentTotals } from '../../types/calculations'
import { SummaryRow } from './SummaryRow'
import { TaxLabel } from './TaxLabel'
import { useTaxSystem } from '../../hooks/useTaxSystem'
import { useCompanyStore } from '../../store/company/companyStore'
import { useFFEStore } from '../../store/ffeStore'

const { Text } = Typography

interface Props {
  totals: DocumentTotals
}

export const TotalSummary: React.FC<Props> = ({ totals }) => {
  const taxSystem = useTaxSystem()
  const { settings: documentSettings } = useFFEStore((state) => state.document)
  const { settings } = useCompanyStore((state) => state.company)

  return (
    <Space direction="vertical" className="w-full" size="small">
      {!documentSettings.taxInclusive && (
        <>
          <SummaryRow label="Subtotal" value={totals.subtotal} />

          <SummaryRow
            label={(<TaxLabel rate={settings.taxRate} />) as unknown as string}
            value={totals.tax}
          />
        </>
      )}

      <SummaryRow label="Total" value={totals.total} strong />

      {documentSettings.taxInclusive && (
        <Text type="secondary" className="text-sm">
          * Prices include {taxSystem.name} at {settings.taxRate}%
        </Text>
      )}
    </Space>
  )
}
